var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fin-time-and-tags',{staticClass:"mb-1",attrs:{"tag":_vm.showTag ? _vm.value.category.id : null,"datetime":_vm.value.datePublished,"datetimePrepend":_vm.value.source.id + ' - '}})}
var staticRenderFns = []

export { render, staticRenderFns }